export const homeModalSessionInfo = {
  homeModalSessionInfotitle: "欢迎回来！",
  homeModalSessionInfotitleCurrentBalance: "当前余额",
  homeModalSessionInfoLastConnection: "最后访问",
  homeModalSessionInfoLastConnectionAtTime: "在",
  homeModalSessionInfoLowBalanceWarning: "您的余额不足。您想要存入更多资金吗？",
  homeModalSessionInfoGoToDeposit: "存入",
  homeModalSessionInfoContinue: "继续",
  homeModalSessionInfoDeposit: "您想要存入更多资金吗？",
};
